module.exports = __webpack_public_path__ + "img/Z85-X18-中_09.88d0391d.jpg";